import { render, staticRenderFns } from "./image.vue?vue&type=template&id=12d9a518"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d9a518')) {
      api.createRecord('12d9a518', component.options)
    } else {
      api.reload('12d9a518', component.options)
    }
    module.hot.accept("./image.vue?vue&type=template&id=12d9a518", function () {
      api.rerender('12d9a518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickAdminTable/image.vue"
export default component.exports